var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var debug = require('debug');

var _require = require('./utils'),
    retrieveSigningKeys = _require.retrieveSigningKeys;

var _require2 = require('./wrappers'),
    request = _require2.request,
    cacheSigningKey = _require2.cacheSigningKey,
    rateLimitSigningKey = _require2.rateLimitSigningKey,
    getKeysInterceptor = _require2.getKeysInterceptor,
    callbackSupport = _require2.callbackSupport;

var JwksError = require('./errors/JwksError');

var SigningKeyNotFoundError = require('./errors/SigningKeyNotFoundError');

var JwksClient =
/*#__PURE__*/
function () {
  "use strict";

  function JwksClient(options) {
    _classCallCheck(this, JwksClient);

    this.options = _objectSpread({
      rateLimit: false,
      cache: true,
      timeout: 30000
    }, options);
    this.logger = debug('jwks'); // Initialize wrappers.

    if (this.options.getKeysInterceptor) {
      this.getSigningKey = getKeysInterceptor(this, options);
    }

    if (this.options.rateLimit) {
      this.getSigningKey = rateLimitSigningKey(this, options);
    }

    if (this.options.cache) {
      this.getSigningKey = cacheSigningKey(this, options);
    }

    this.getSigningKey = callbackSupport(this, options);
  }

  _createClass(JwksClient, [{
    key: "getKeys",
    value: function getKeys() {
      var res, errorMsg;
      return _regeneratorRuntime.async(function getKeys$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.logger("Fetching keys from '".concat(this.options.jwksUri, "'"));
              _context.prev = 1;
              _context.next = 4;
              return _regeneratorRuntime.awrap(request({
                uri: this.options.jwksUri,
                headers: this.options.requestHeaders,
                agent: this.options.requestAgent,
                timeout: this.options.timeout,
                fetcher: this.options.fetcher
              }));

            case 4:
              res = _context.sent;
              this.logger('Keys:', res.keys);
              return _context.abrupt("return", res.keys);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              errorMsg = _context.t0.errorMsg;
              this.logger('Failure:', errorMsg || _context.t0);
              throw errorMsg ? new JwksError(errorMsg) : _context.t0;

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[1, 9]]);
    }
  }, {
    key: "getSigningKeys",
    value: function getSigningKeys() {
      var keys, signingKeys;
      return _regeneratorRuntime.async(function getSigningKeys$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _regeneratorRuntime.awrap(this.getKeys());

            case 2:
              keys = _context2.sent;

              if (!(!keys || !keys.length)) {
                _context2.next = 5;
                break;
              }

              throw new JwksError('The JWKS endpoint did not contain any keys');

            case 5:
              signingKeys = retrieveSigningKeys(keys);

              if (signingKeys.length) {
                _context2.next = 8;
                break;
              }

              throw new JwksError('The JWKS endpoint did not contain any signing keys');

            case 8:
              this.logger('Signing Keys:', signingKeys);
              return _context2.abrupt("return", signingKeys);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "getSigningKey",
    value: function getSigningKey(kid) {
      var keys, kidDefined, key;
      return _regeneratorRuntime.async(function getSigningKey$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              this.logger("Fetching signing key for '".concat(kid, "'"));
              _context3.next = 3;
              return _regeneratorRuntime.awrap(this.getSigningKeys());

            case 3:
              keys = _context3.sent;
              kidDefined = kid !== undefined && kid !== null;

              if (!(!kidDefined && keys.length > 1)) {
                _context3.next = 8;
                break;
              }

              this.logger('No KID specified and JWKS endpoint returned more than 1 key');
              throw new SigningKeyNotFoundError('No KID specified and JWKS endpoint returned more than 1 key');

            case 8:
              key = keys.find(function (k) {
                return !kidDefined || k.kid === kid;
              });

              if (!key) {
                _context3.next = 13;
                break;
              }

              return _context3.abrupt("return", key);

            case 13:
              this.logger("Unable to find a signing key that matches '".concat(kid, "'"));
              throw new SigningKeyNotFoundError("Unable to find a signing key that matches '".concat(kid, "'"));

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this);
    }
  }]);

  return JwksClient;
}();

module.exports = {
  JwksClient: JwksClient
};